import { hotRanking } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

const statusStyles: Record<string, string> = {
  已澄清: 'bg-secondary-100 text-secondary-900',
  复核中: 'bg-accent-100 text-accent-900',
  反转中: 'bg-primary-100 text-primary-800',
};

export default function HotRankingSection() {
  return (
    <section id="ranking" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeading
            index="01"
            eyebrow="Hot Ranking"
            title="今日澄清热度榜"
            desc="按讨论热度排序，热度高不代表结论已定。每一行都标注当前复核状态，点开前先看清它停在哪一步。"
          />
          <p className="flex items-center gap-2 whitespace-nowrap font-label text-xs text-foreground-500">
            <i className="ri-refresh-line text-sm text-primary-600" />
            榜单每小时更新一次
          </p>
        </div>

        <div
          data-reveal
          className="mt-10 overflow-hidden rounded-lg border border-background-200 bg-background-100/60"
        >
          {hotRanking.map((item, index) => (
            <article
              key={item.rank}
              className={`group grid grid-cols-1 gap-4 px-5 py-6 transition-colors duration-200 hover:bg-background-50 md:grid-cols-12 md:items-center md:gap-6 md:px-8 md:py-7 ${
                index !== 0 ? 'border-t border-background-200' : ''
              }`}
            >
              <div className="flex items-center gap-4 md:col-span-1 md:block">
                <span
                  className={`font-heading text-3xl font-bold leading-none md:text-[40px] ${
                    index < 3 ? 'text-primary-500' : 'text-background-400'
                  }`}
                >
                  {item.rank}
                </span>
              </div>

              <div className="md:col-span-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-500 px-2.5 py-1 font-label text-[11px] font-medium text-accent-950">
                    {item.tag}
                  </span>
                  <span
                    className={`rounded-full px-2.5 py-1 font-label text-[11px] font-medium ${
                      statusStyles[item.status] ?? 'bg-background-200 text-foreground-800'
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                  {item.summary}
                </p>
              </div>

              <div className="md:col-span-5 md:pl-4">
                <div className="flex items-center justify-between">
                  <span className="font-label text-[11px] tracking-[0.18em] text-foreground-500 uppercase">
                    讨论热度
                  </span>
                  <span className="font-heading text-lg font-bold text-foreground-950">
                    {item.heat}
                  </span>
                </div>
                <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                    style={{ width: `${item.bar}%` }}
                  />
                </div>
                <a
                  href="#latest"
                  className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-xs text-primary-700 transition-colors duration-200 hover:text-primary-500"
                >
                  查看澄清依据
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-2 font-label text-xs leading-relaxed text-foreground-500">
          <i className="ri-information-line mt-0.5 text-sm text-accent-600" />
          热度仅代表讨论量，不构成事实认定。榜单内条目均附有可核对的时间线与原始出处。
        </p>
      </div>
    </section>
  );
}